import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { CREATE_SOP_MUTATION } from '../graphql/mutations'
import { transformToSaveSop } from '../graphql/transformers'
import { CREATE_SOP } from '../redux/action-types'

const useCreateSopMutation = () => {
  const dispatch = useDispatch()
  const { isCreating, creatingError } = useSelector(store => store.sops.sops)

  const mutate = useCallback(
    (sop, onSuccess) =>
      apolloService.mutate({
        mutation: CREATE_SOP_MUTATION,
        variables: { data: transformToSaveSop(sop) },
        dispatch,
        action: CREATE_SOP,
        onSuccess,
      }),
    [dispatch],
  )

  return [mutate, { isLoading: isCreating, error: creatingError }]
}

export default useCreateSopMutation
